import React from 'react';
import Image from 'next/image';

const FlagImage: React.FC<any> = ({ countryCode }) => {
    return (
        <Image src={`/assets/flags/${countryCode?.toLocaleLowerCase()}.svg`}
            alt={`Flag of ${countryCode}`}
            width={20}
            height={15}
        />
    );
};

export default FlagImage;